<div class="card">
  <div class="card-header">
    <form [formGroup]="form" class="form-row">
      <div class="form-group col">
        <div class="input-group">
          <input autocomplete="off" type="search" class="form-control" id="search" autofocus="true"
            formControlName="inquiry"
            placeholder="{{ words[language]['typeToFilterOut'] }} {{ words[language]['vehicles'] }}">
          <div class="input-group-append">
            <span class="input-group-text"><span class="mdi mdi-magnify search-icon"></span></span>
          </div>
        </div>
      </div>
      <div class="form-group col">
        <select class="form-control" name="status" id="status-filter" formControlName="status">
          <option value="">All statuses</option>
          @for (status of statuses; track status) {
            <option [value]="status.id">{{status.name}}</option>
          }
        </select>
      </div>
    </form>
  </div>
  <div class="card-body p-0 pb-1">
    <div id="listing" class="col-md-12 scroll-list" (scroll)="scrolled($event)">
      @if (vehicles) {
        <table class="table table-sm" id="vehicleTable">
          <thead>
            <tr>
              @if (hasGPS) {
                <th scope="col"></th>
              }
              <th scope="col"></th>
              <th scope="col">{{ words[language]['Year'] }} {{ words[language]['Make'] }} {{words[language]['Model'] }}</th>
              <th scope="col">{{ words[language]['Stock Number'] }}</th>
              <th scope="col">{{ words[language]['VIN Number'] }}</th>
              <th scope="col">{{ words[language][ 'Inventory Status' ] }}</th>
              <th scope="col">Actions</th>
            </tr>
          </thead>
          @for (item of vehicles; track item; let i = $index) {
            <tbody>
              <tr class="text-dark">
                @if (hasGPS) {
                  <th scope="col" class="accordion custom-accordion text-dark btn-sm">
                    <a data-toggle="collapse" class="btn btn-xs btn-light" href="#collapse_{{i}}"
                      aria-expanded="true" (click)="listGPSDevicesForVehicle(item.vehicleId)">
                      <span class="mdi mdi-chevron-down"></span>
                      <span class="link-primary text-decoration-underline link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover">{{item.deviceCount}}</span>
                    </a>
                  </th>
                }
                <td>@if (item.url) {
                  <img [src]="item.url" [alt]="item.model" />
                }</td>
                <td>
                  <div class="flex-start">
                    <span class="pallette"
                    [style.backgroundColor]="item.exteriorColor ? item.exteriorColor.toLowerCase() : null">&nbsp;</span>
                    <span class="pallette"
                    [style.backgroundColor]="item.interiorColor ? item.interiorColor.toLowerCase() : null">&nbsp;</span>
                    <span>{{item.year}} {{item.make}} {{item.model}}</span>
                  </div>
                </td>
                <td scope="row">{{item.stock}}</td>
                <td scope="row">{{item.vin}}</td>
                <td>{{item.status}}</td>
                <td class="action-items">
                  <button class="btn btn-primary btn-sm" (click)="assignSetup(item)">Assign</button>
                </td>
              </tr>
              @if (hasGPS) {
                <tr id="collapse_{{i}}" class="collapse">
                  <td colspan="7" class="indent-lvl-1">
                    <table class="table mb-0 border-0">
                      <thead>
                        <tr>
                          <th scope="col">{{ words[language][ 'Device Info' ] }}</th>
                          <th scope="col">{{ words[language][ 'Device Provider' ] }}</th>
                          <th scope="col">{{ words[language][ 'Device Serial Number' ] }}</th>
                          <th scope="col">{{ words[language][ 'Installed By' ] }}</th>
                          <th scope="col">{{ words[language][ 'Device Location' ] }}</th>
                          <th scope="col">{{ words[language][ 'Actions' ] }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        @if (loading) {
                          <span class="spinner-grow spinner-grow-sm mr-1" role="status"
                          ></span>
                        }
                        @for (device of item['devices']; track device) {
                          <tr>
                            <td>{{device.productName}}
                              <span title="{{device.gpsDeviceStatus}}">
                                <span class="mdi mdi-checkbox-blank-circle text-success show"
                                [ngClass]="{'d-none' : device.gpsDeviceStatus != 'Assigned'}"></span>
                                <span class="mdi mdi-checkbox-blank-circle text-warning show"
                                [ngClass]="{'d-none' : device.gpsDeviceStatus != 'Inactive'}"></span>
                              </span>
                            </td>
                            <td>{{device.integrationCompanyName}}</td>
                            <td>{{device.serialNumber}}</td>
                            <td>{{device.installedBy}}</td>
                            <td>{{device.deviceLocation}}</td>
                            <td class="action-items">
                              <div class="dropdown">
                                <button class="btn btn-light dropdown-toggle" type="button"
                                  id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                                  aria-expanded="false">
                                  Actions
                                </button>
                                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                  <button class="dropdown-item" (click)="editAssignmentSetup(device, item)">Edit</button>
                                  <button class="dropdown-item">Deactivate</button>
                                  <button class="dropdown-item" (click)="removeAssignmentSetup(device, item)">Remove</button>
                                </div>
                              </div>
                            </td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </td>
                </tr>
              }
            </tbody>
          }
        </table>
      }
    </div>
    <p class="list-footer text-muted">{{displayed | number: '1.0-0'}} / {{records | number: '1.0-0'}}
    {{words[language]['displayed']}}</p>
  </div>
</div>

<!-- Large modal -->
<a class="btn btn-info d-none" data-toggle="modal" href="#assign-modal-{{hasGPS}}" id="assign-modal-btn-{{hasGPS}}"></a>
<div class="modal fade" id="assign-modal-{{hasGPS}}" data-backdrop="static" tabindex="-1" role="dialog"
  aria-labelledby="mySmallModalLabel">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        @if (selectedVehicleData != null) {
          <h4 class="modal-title" id="myLargeModalLabel">Assign Device to
          {{selectedVehicleData.year}} {{selectedVehicleData.make}} {{selectedVehicleData.model}}</h4>
        }
        <button type="button" class="btn btn-close" data-dismiss="modal">x</button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-7">
            <div class="card-title">Select an Unassigned Device</div>
            @if (unassigned && unassigned.length > 0) {
              <table class="table table-sm table-responsive">
                <thead>
                  <tr>
                    <th>Provider Name</th>
                    <th>Product Name</th>
                    <th>Serial Number</th>
                  </tr>
                </thead>
                <tbody>
                  @for (device of unassigned; track device) {
                    <tr class="clickable device-list"
                      [id]="device.id" (click)="selectDevice(device)">
                      <td>{{device.integrationCompany.name}}</td>
                      <td>{{device.productName}}</td>
                      <td>{{device.serialNumber}}</td>
                    </tr>
                  }
                </tbody>
              </table>
            }
            @if (unassigned && unassigned.length == 0 || gpsDevices.length == 0) {
              <p class="subtitle">No
                devices available to be
              assigned.</p>
            }
          </div>
          <div class="col-5">
            <form [formGroup]="gpsInventoryAssignmentInformation">
              <div class="row">
                <div class="form-group col-md-12 col-sm-12">
                  <label class="text-nowrap" for="deviceLocation">Device Location</label>
                  <input class="form-control form-control-sm text-dark" type="text"
                    id="deviceLocation" name="deviceLocation" formControlName="deviceLocation">
                </div>
                <div class="form-group col-md-12 col-sm-12">
                  <label class="text-nowrap" for="installedBy">Installed By</label>
                  <input class="form-control form-control-sm text-dark" type="text" id="installedBy"
                    name="installedBy" formControlName="installedBy">
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-link" [disabled]="gpsInventoryAssignmentInformation.invalid"
        (click)="assignDevice()">Assign & Close</button>
        <button class="btn btn-link" data-dismiss="modal" id="btn-close-modal-inventory-list-{{hasGPS}}"
          (click)="resetForm()"><span class="text-muted">Cancel</span></button>
        </div>
      </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
  </div><!-- /.modal -->


  <!-- Large modal -->
  <a class="btn btn-info d-none" data-toggle="modal" href="#edit-modal-{{hasGPS}}" id="edit-modal-btn-{{hasGPS}}"></a>
  <div class="modal fade" id="edit-modal-{{hasGPS}}" data-backdrop="static" tabindex="-1" role="dialog"
    aria-labelledby="mySmallModalLabel">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          @if (selectedVehicleData != null) {
            <h4 class="modal-title" id="myLargeModalLabel">Edit Device for
            {{selectedVehicleData.year}} {{selectedVehicleData.make}} {{selectedVehicleData.model}}</h4>
          }
          <button type="button" class="btn btn-close" data-dismiss="modal">x</button>
        </div>
        <div class="modal-body">
          <form [formGroup]="gpsInventoryAssignmentInformation">
            <div class="row">
              <div class="form-group col-md-12 col-sm-12">
                <label class="text-nowrap" for="deviceLocation">Device Location</label>
                <input class="form-control form-control-sm text-dark" type="text" id="deviceLocation"
                  name="deviceLocation" formControlName="deviceLocation">
              </div>
              <div class="form-group col-md-12 col-sm-12">
                <label class="text-nowrap" for="installedBy">Installed By</label>
                <input class="form-control form-control-sm text-dark" type="text" id="installedBy"
                  name="installedBy" formControlName="installedBy">
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button class="btn btn-link" [disabled]="gpsInventoryAssignmentInformation.invalid"
          (click)="editDeviceAssignment()">Save & Close</button>
          <button class="btn btn-link" data-dismiss="modal" id="btn-close-modal-inventory-list-{{hasGPS}}"
            (click)="resetForm()"><span class="text-muted">Cancel</span></button>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div><!-- /.modal -->